import React from 'react';
import styled, { css } from 'styled-components';

import { H5Size, H5LineHeight } from '../../constants/text';

export const h5Style = css`
  font-size: ${H5Size};
  line-height: ${H5LineHeight};
  font-weight: 500;
`;

export const StyledH5 = styled.h5`
  ${h5Style}
`;

export const H5 = (props) => {
  const { children } = props;

  return <StyledH5 {...props}>{children}</StyledH5>;
};
